import { Fragment } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import logo from '../public/img/logo.svg'
import language from '../languages/Footer.json'
import ContactUsCTA from './ContactUsCTA';
import { LinkedinIcon, TwitterIcon, InstagramIcon } from './icons/Icon';


const Footer = ({locale}) => {
    return (
        <Fragment>
            <div className="footer">
                <div className="section section-40">
                    <div className="logo">
                        <Link locale={locale} href="/"><a><Image src={logo} alt="Inspektlabs- AI Vehicle Inspection Solution" /></a></Link>
                    </div>

                    {/* <div className="social-container">
                        <a href="https://www.linkedin.com/company/inspektlabs" target="_blank" rel="noreferrer noopener"><i className="fab fa-linkedin fa-2x" title="LinkedIn"></i></a>
                        <a href="https://angel.co/company/inspekt-labs" target="_blank" rel="noreferrer noopener"><i className="fab fa-angellist fa-2x" title="AngelList"></i></a>
                        <a href="https://www.crunchbase.com/organization/inspektlabs" target="_blank" rel="noreferrer noopener"><Image className="customIcon" src="/img/cb.svg" width={28} height={32} alt="Crunchbase" /></a>
                        <a href="https://twitter.com/InspektlabsAI" target="_blank" rel="noreferrer noopener"><i className="fab fa-twitter fa-2x" title="Twitter"></i></a>
                        <a href="https://www.instagram.com/inspektlabs" target="_blank" rel="noreferrer noopener"><i className="fab fa-instagram fa-2x" title="Instagram"></i></a>
                    </div> */}

                    <h2 className='footerSubHeading'>{language["Our products conduct damage"][locale]} </h2>
                    <ContactUsCTA as="div" cluster = "footer" type="try-our-product" location="footer" className="getInTouchBtn">
                        Try Our Product
                    </ContactUsCTA>
                </div>
                <div className="section contact-section">
                    <div>
                        <p className='location-heading'>Our Location</p>
                        <ul className="footer-nav">
                            <li><p>HEAD OFFICE</p></li>
                            <li>
                                <p>651 N, Broad St, Suit 206, Middletown, New Castle, Delaware, USA, 19709</p>
                            </li>
                            <li>
                                <p>Bargelaan 200, 2333 CW Leiden, The Netherlands</p>
                            </li>
                            {/* <li><p>Cvision.ai analytics pvt ltd</p></li> */}
                        </ul>
                    </div>
                    <div>
                        <p className='location-heading'>PHONE</p>
                        <p>+1 302 613 1607</p>
                    </div>
                    <div>
                        <p className='location-heading'>EMAIL</p>
                        <p>info@inspektlabs.com</p>
                    </div>
                </div>
                {/* <div className="section">
                    <h3>{language["Quick Links"][locale]}</h3>
                    <ul className="footer-nav">
                        <li>
                            <Link locale={locale} href="/">{language["Home"][locale]}</Link>
                        </li>
                        <li>
                            <Link locale={locale} href="/photo-video-capture">{language["How it works"][locale]}</Link>
                        </li>
                        <li>
                            <Link href="/whitepapers">Resources</Link>
                        </li>
                        <li>
                            <Link href="/security">Security</Link>
                        </li>                    
                    </ul>
                </div> */}
                <div className="section">
                    <div>
                        <p className='location-heading'>BUSINESS</p>
                        <ul className="footer-nav">
                            <li className="footer-links">
                                <Link locale={locale} href="/">{language["Home"][locale]}</Link>
                            </li>
                            <li className="footer-links">
                                <Link locale={locale} href="/photo-video-capture">{language["How it works"][locale]}</Link>
                            </li>
                            <li className="footer-links">
                                <Link locale={locale} href="/privacy-policy">{language["Privacy Policy"][locale]}</Link>
                            </li>
                            <li className="footer-links">
                                <Link locale={locale} href="/terms-and-conditions">{language["Terms of Service"][locale]}</Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className='location-heading'>Visit us on</p>
                        <div className="social-container">
                            <a href="https://www.linkedin.com/company/inspektlabs" title="Inspektlabs on LinkedIn" target="_blank" rel="noreferrer noopener"><LinkedinIcon width="1.6em" height="1.6em" title="LinkedIn" /></a>
                            <a href="https://wellfound.com/company/inspekt-labs" title="Inspektlabs on WellFound" target="_blank" rel="noreferrer noopener"><Image className="customIcon" src="/img/wellfound-symbol-black.webp" width={28} height={32} alt="Wellfound" /></a>
                            <a href="https://www.crunchbase.com/organization/inspektlabs" title="Inspektlabs on Crunchbase" target="_blank" rel="noreferrer noopener"><Image className="customIcon" src="/img/cb.svg" width={28} height={32} alt="Crunchbase" /></a>
                            <a href="https://twitter.com/InspektlabsAI" title="Inspektlabs on Twitter" target="_blank" rel="noreferrer noopener"><TwitterIcon width="1.6em" height="1.6em" title="Twitter" /></a>
                            <a href="https://www.instagram.com/inspektlabs" title="Inspektlabs on Instagram" target="_blank" rel="noreferrer noopener"><InstagramIcon width="1.6em" height="1.6em" title="Instagram" /></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p>&copy; Copyright { new Date().getFullYear() } {language["Inspektlabs Inc. All rights reserved"][locale]}</p>
            </div>
        </Fragment>
    )
}

export default Footer